import 'vuetify/dist/vuetify.min.css';
import { vuetifyBaseConfig } from 'elixir-theme';

export default {
  ...vuetifyBaseConfig,
};
